<div class="min-h-screen w-full flex flex-col">
  <app-header></app-header>
  <app-toolbar></app-toolbar>
  <app-submenu [items]="subMenuItems" [backBgGray]="true"></app-submenu>

  <main class="flex-1 bg-[#f6f6f6] pb-20 pt-10">
    <section class="bg-white border border-[#f0f0f0] rounded-[15px] mx-auto w-[95%] max-w-[1200px] p-2 shadow-[1px_1px_20px_0px_rgba(0,0,0,0.1)]">
      <div class="flex gap-2 flex-wrap justify-end mt-4 mb-5">
        <button type="button" (click)="exportExcel()" [disabled]="!utils.validatePermission('download_cash_opening_and_closing_summaries')" class="bg-green-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52 mb-2">
          Exportar excel
        </button>
      </div>
      <div class="flex gap-2 flex-wrap justify-between mt-4 mb-5">
        <div class="filter-calendar-container">
          <p-calendar 
            styleClass="bg-white border border-[#A3A3A3] px-[20px] py-[10px] rounded-[12px]" 
            (onSelect)="filterResults(textToSearch)"
            (onInput)="filterResults(textToSearch)"
            [(ngModel)]="dateFilter"
            placeholder="Filtro fecha"
          ></p-calendar>
        </div>
        <div class="filter-office">
          <select class="bg-white border border-[#A3A3A3] px-[20px] py-[10px] rounded-[12px]" id="" (change)="filterResults(textToSearch)" [(ngModel)]="officeFilter">
            <option value="">Seleccione oficina</option>
            <ng-container *ngFor="let office of offices">
              <option [value]="office.id">
                {{ office.name }}
              </option>
            </ng-container>
          </select>
        </div>
        <div class="search w-full max-w-[300px]">
          <div class="search-box flex align-middle pl-8  w-full bg-[#f0f0f0] rounded-[10px] h-10">
            <input #filter [(ngModel)]="textToSearch" (input)="filterResults(textToSearch)"
              class="form-control" placeholder="BUSCAR RESERVA/TITULAR">
          </div>
        </div>
      </div>
      
      <div class="">
        <p-table 
          [value]="filteredCashiers"   
          styleClass="p-datatable-striped" 
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [rows]="7"
        >
          <ng-template pTemplate="header">
              <tr>
                  <th scope="col" class="px-3 py-1">
                    Oficina
                  </th>
                  <th scope="col" class="px-3 py-1">
                    Responsable apertura
                  </th>
                  <th scope="col" class="px-3 py-1">
                    Responsable cierre
                  </th>
                  <!-- <th scope="col" class="px-3 py-1">
                    Recuento de efectivo
                  </th> -->
                  <th scope="col" class="px-3 py-1">
                    Total efectivo
                  </th>
                  <!-- <th scope="col" class="px-3 py-1">
                    Tipo de operación
                  </th> -->
                  <th scope="col" class="px-3 py-1">
                    Fecha/Hora Apertura
                  </th>
                  <th scope="col" class="px-3 py-1">
                    Fecha/Hora Cierre
                  </th>
                  <th scope="col" class="px-3 py-1">
                    Acciones
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-cashier>
              <tr>
                  <td>{{ cashier.office?.name }}</td>
                  <td>{{ cashier.user_opens?.name }}</td>
                  <td>{{ cashier.user_closes?.name }}</td>
                  <!-- <td class=" max-w-[250px]"  [innerHTML]="cashier.coin_counter"></td> -->
                  <td class="text-right">{{ cashier.total.toFixed(2) }}€</td>
                  <!-- <td>{{ cashier.operation_type }}</td> -->
                  <td>{{ cashier.datetime_open }}</td>
                  <td>{{ cashier.datetime_close }}</td>
                  <td>
                    <ng-container *ngIf="cashier.canPrint">
                      <button (click)="printTicketFromCashier(cashier.id)" class="rounded-[12px] bg-[#27368a] text-white font-bold py-2
                       px-7" >imprimir</button>
                    </ng-container>
                  </td>
              </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody">
            <tr>
              <td colspan="5" class="text-center">Cargando datos...</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center">No hay datos disponibles</td>
            </tr>
          </ng-template>
      </p-table>
      </div>
    </section>
  </main>

</div>
